import { FC, useState } from 'react';
import { useDispatch } from 'react-redux';
import filter from 'lodash/filter';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import Button from 'antd/lib/button/button';
import Divider from 'antd/lib/divider';

import Columns from 'components/CustomizeDisplayTable/Columns';
import { tableSettingsByTypeSelector } from 'store/selectors/listsSelectors';
import { updateTableSettingsByTypeAction } from 'store/actions/listsActions';
import { useTypedSelector } from 'hooks/useTypedSelector';
import { ICustomizeTableProps, tableLocalStorageKeyByType } from 'components/CustomizeDisplayTable/constants';
import { ICustomizeTableColumn } from 'types/listsTypes';

const CustomizeDisplayTable: FC<ICustomizeTableProps> = ({ listType, onModalClose }) => {
  const dispatch = useDispatch();
  const columns = useTypedSelector((state) => tableSettingsByTypeSelector(state, { listType }));
  const [fixedColumns, setFixedColumns] = useState<ICustomizeTableColumn[]>(filter(columns, 'isFixed'));
  const [draggableColumns, setDraggableColumns] = useState<ICustomizeTableColumn[]>(
    filter(columns, ({ isFixed }) => !isFixed));

  const handleUpdate = () => {
    const tableSettings = [...fixedColumns, ...draggableColumns];

    localStorage.setItem(tableLocalStorageKeyByType[listType], JSON.stringify(tableSettings));
    dispatch(updateTableSettingsByTypeAction({ listType, tableSettings }));
    onModalClose();
  };

  return (
    <DndProvider backend={HTML5Backend}>
      <h2 className="my-4">Customize Display</h2>
      <Columns columns={fixedColumns} setColumns={setFixedColumns} />
      <Divider className="rounded-lg border-4 border-black-20 my-4 dark:border-black-80" />
      <Columns columns={draggableColumns} setColumns={setDraggableColumns} />
      <Divider className="mt-4" />
      <Button type="primary" size="large" className="block ml-auto" onClick={handleUpdate}>Update</Button>
    </DndProvider>
  );
};

export default CustomizeDisplayTable;
